import updateConversationRelations from '../../utils/updateConversationRelations';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { getTableConversationRelation, getRowIdsFromRowKeys } from 'owa-mail-list-store';
import FlagType from 'owa-service/lib/contract/FlagType';
import { ObservableMap } from 'mobx';
import { action, select } from 'satcheljs/lib/legacy';

export interface ApplyConversationFlagInListViewStoreState {
    tableViews: ObservableMap<string, TableView>;
}

/**
 * Apply flag state on the conversations in list view store
 * @param rowKeys for the conversations
 * @param flagType the flag type to apply
 * @param tableViewId the table view id
 * @param state the ApplyConversationFlagInListViewStore state used for this action
 */
export default select<ApplyConversationFlagInListViewStoreState>({
    tableViews: () => listViewStore.tableViews,
})(
    action('ApplyConversationFlagInListViewStore')(function applyConversationFlag(
        rowKeys: string[],
        flagType: FlagType,
        tableViewId: string,
        state?: ApplyConversationFlagInListViewStoreState
    ) {
        if (!flagType || !flagType.FlagStatus) {
            throw new Error('Invalid flag type.');
        }

        const tableView = state.tableViews.get(tableViewId);

        // Create the map to hold all unique item ids.
        // This is used to update tableConversationRelation in other table views.
        const itemIdsToUpdate = {};

        // Gather the item ids to be updated by going through each conversation
        rowKeys.forEach(rowKey => {
            const tableConversationRelation = getTableConversationRelation(rowKey, tableView.id);

            if (flagType.FlagStatus == 'Flagged') {
                // For mark as flag, only flag the latest item in the conversation and put it in the map.
                // It is always the first item in the itemIds array in FindConversation response,
                // regardless of the conversationSortOrder(NewestOnBottom or NewestOnTop).
                const latestItemId = tableConversationRelation.itemIds[0];
                itemIdsToUpdate[latestItemId] = 1;
            } else {
                // For unflagging or complete, apply to all items in this conversation
                tableConversationRelation.itemIds.forEach(itemId => {
                    itemIdsToUpdate[itemId] = 1;
                });
            }
        });

        // Update the tableConversationRelation in all table views of the current folder
        const rowIdStrings = getRowIdsFromRowKeys(rowKeys, tableView.id);
        updateConversationRelations(
            rowIdStrings,
            tableView.serverFolderId,
            itemIdsToUpdate,
            (relation, itemId) => {
                relation.flagStatus = flagType.FlagStatus;
            }
        );
    })
);
